import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import LeaderSection from "@/components/LeaderSection";
import ReviewsSlider from "@/components/ReviewsSlider";
import CouponSection from "@/components/CouponBanner";
import CTASection from "@/components/CTASection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import FixedSocialIcons from "@/components/FixedSocialIcons";
import ServiceDetailPage from "@/components/ServiceDetailPage";
import SplashScreen from "@/components/SplashScreen";
import CouponPopup from "@/components/CouponPopup";

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      document.documentElement.classList.add("loaded");
    }, 2500);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <WhyChooseUs />
        <LeaderSection />
        <ReviewsSlider />
        <CouponSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}

function ServicePage() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <ServiceDetailPage />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white" data-testid="app-root">
        <SplashScreen />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hizmetler/:serviceId" element={<ServicePage />} />
        </Routes>
        <FixedSocialIcons />
        <CouponPopup />
      </div>
    </BrowserRouter>
  );
}

export default App;
